import { Component, OnInit } from '@angular/core';
import {icomoonList} from '../icomoon-list';

@Component({
  selector: 'app-jb-no-data-demo',
  templateUrl: './jb-no-data-demo.component.html',
  styleUrls: ['./jb-no-data-demo.component.scss']
})
export class JbNoDataDemoComponent implements OnInit {
  public name = jbNoDataDoc.name;
  public desc = jbNoDataDoc.desc;
  public api = jbNoDataDoc.api;
  public instance = jbNoDataDoc.instance;

  public instance2 = `<div class="row whiteBg">
  <jb-no-data class="col-12"
              [jbIsPlaceholder]="true"
              jbIcon="icon-tape"
              jbTitle="view.voicemails.no_voicemails_title"
              jbDescription="view.voicemails.no_voicemails">              
  </jb-no-data>
</div>`;


  public cssReset = `$no-data-bg: darken($primary_color, 20%) !default;
$no-data-color: $white !default;
$placeholder-color: $primary !default`;

  public iconList = icomoonList;


  // ---- This is the logic to manage autogenerated code example ----
  public brStr = `\n`;
  public bsStr = `\n             `;
  public customCompCode = `<jb-no-data></jb-no-data>`;
  public compConf: any = {
    jbMessage: 'view.common.username', hasLabel: false,
    isPlaceholder: true,
    jbIcon: 'icon-hour-glass',
    jbTitle: 'view.voicemails.no_voicemails_title',
    jbDescription: 'view.voicemails.no_voicemails',
    sizeClass: 'size-xl',
  };
  public upComp = () => {
    this.customCompCode = `<jb-no-data `;
    let compClasses = '';
    if (this.compConf.sizeClass !== 'size-xl') { compClasses += this.compConf.sizeClass; }
    if (!!compClasses) { this.customCompCode += `class="${compClasses}"` + this.bsStr; }

    if (!this.compConf.isPlaceholder) {
      if (this.compConf.hasLabel) { this.customCompCode += ` jbMessage="${this.compConf.jbMessage}"`; }

    } else {
      this.customCompCode += ` [jbIsPlaceholder]="true"`;
      if (this.compConf.jbIcon)        { this.customCompCode += this.bsStr + `jbIcon="${this.compConf.jbIcon}"`; }
      if (this.compConf.jbTitle)       { this.customCompCode += this.bsStr + `jbTitle="${this.compConf.jbTitle}"`; }
      if (this.compConf.jbDescription) { this.customCompCode += this.bsStr + `jbDescription="${this.compConf.jbDescription}"`; }

    }

    this.customCompCode += (`>` + this.brStr + `</jb-no-data>`);
  };





  constructor() { }

  ngOnInit() {
    this.upComp();
  }

}


export const jbNoDataDoc = {
  name    : `jb-no-data`,
  uiType  : 'component',
  desc    : `Generates an alert with the no data placeholder`,
  api     : `[jbMessage]       : The message to display (by default = 'view.common.no_data_to_show')
[jbIsPlaceholder] : (true/false) Whether to style as an empty list placeholder (true) or a "No Data" bg row (false) 
[jbIcon]          : If placeholder, the icon class to display
[jbTitle]         : If placeholder, the title (eg: No users yet)
[jbDescription]   : If placeholder, the description (eg: Click to add a new user)`,
  instance: `<div class="row whiteBg">
  <jb-no-data></jb-no-data>
</div>`,
  demoComp: JbNoDataDemoComponent
};
